var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "scroll-primary"
  }, [_c('v-img', {
    staticClass: "pdfImg",
    attrs: {
      "src": _vm.value.page.pageUrl
    }
  }, _vm._l(_vm.fieldsPerPage, function (field) {
    return _c('worker-form-field', {
      key: field.dataLabel,
      attrs: {
        "value": field
      }
    });
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }